import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

export default function useCreateClientVroomConfiguration() {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Crée la configuration VROOM par défaut d'un client qui n'en a pas (sans
   * elle, l'optimisation du puits est impossible).
   * @param {number} clientId - L'identifiant du client
   * @returns {Promise<object|null>} La configuration créée, ou null en cas d'erreur
   */
  const createVroomConfiguration = async (clientId) => {
    try {
      setIsLoading(true);

      const response = await fleetApi.post(
        `/super-admin/clients/${clientId}/vroom-configuration`
      );

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      toast.success('Configuration VROOM par défaut créée.');

      return response.data.vroom_configuration;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    createVroomConfiguration,
  };
}
